// export const baseApiUrl = "http://127.0.0.1:5000/api/";Add commentMore actions

export const baseApiUrl = "https://lsg.cs.bgu.ac.il/api/";